import { defineStore } from 'pinia';

// TODO: Add more roles?
export type Role = 'admin';

export interface User {
  id: number;
  uid: string;
  provider: string;
  username: string;
  display_name: string;
  profile_image_url: string;
  created: Date;
  roles: Role[];
}

interface UserStoreState {
  loading: boolean;
  user: User | undefined;
}

interface Ownable {
  created_by: number;
}

export const useUserStore = defineStore('users', {
  state: (): UserStoreState => {
    return {
      loading: false,
      user: undefined,
    };
  },
  getters: {
    isLoggedIn(): boolean {
      return this.user !== undefined;
    },
    isLoading(): boolean {
      return this.loading;
    },
    isAdmin(): boolean {
      if (this.user === undefined) {
        return false;
      }
      return this.user.roles.includes('admin');
    },
  },
  actions: {
    async fetchCurrentUser(): Promise<User | undefined> {
      this.loading = true;
      let resp = await fetch('/api/users/me', {
        headers: {
          'content-type': 'application/json',
        },
      });
      const user: User = await resp.json();
      this.loading = false;
      if (user.id !== undefined) {
        this.user = user;
      } else {
        this.user = undefined;
      }
      return this.user;
    },
    async getCurrentUser(): Promise<User | undefined> {
      if (this.isLoggedIn) {
        return this.user;
      }
      return await this.fetchCurrentUser();
    },
    owns(item: Ownable): boolean {
      if (this.user === undefined) {
        return false;
      }
      return item.created_by === this.user.id;
    },
  },
});
